module.exports = __webpack_public_path__ + "img/iframe.f982a181.png";